const VALID_ENTRY_SOURCES = ["app", "espace_assure"];
const VALID_REGIME_TYPES = ["regime-general", "alsace-moselle"];

export const DEFAULT_ENTRY_SOURCE = "espace_assure";
export const DEFAULT_REGIME_TYPE = "regime-general";

function normalizeText(value) {
  return String(value ?? "")
    .trim()
    .toLowerCase();
}

export function isValidRegimeType(value) {
  const normalizedValue = normalizeText(value);
  return VALID_REGIME_TYPES.includes(normalizedValue);
}

export function normalizeSourceEntree(value) {
  const normalizedValue = normalizeText(value);
  return VALID_ENTRY_SOURCES.includes(normalizedValue) ? normalizedValue : DEFAULT_ENTRY_SOURCE;
}

export function normalizeRouteContext(routeParams = {}) {
  const rawSource = normalizeText(routeParams.source);
  const rawRegimeType = normalizeText(routeParams.regimeType);

  let resolvedRegimeType = rawRegimeType;
  if (!resolvedRegimeType && rawSource && !VALID_ENTRY_SOURCES.includes(rawSource)) {
    resolvedRegimeType = rawSource;
  }

  if (!isValidRegimeType(resolvedRegimeType)) {
    resolvedRegimeType = DEFAULT_REGIME_TYPE;
  }

  return {
    sourceEntree: normalizeSourceEntree(rawSource),
    typeRegime: resolvedRegimeType,
    isRegimeFromUrl: isValidRegimeType(rawRegimeType) || (!rawRegimeType && isValidRegimeType(rawSource) && !VALID_ENTRY_SOURCES.includes(rawSource)),
  };
}

export function getSourceEntreeFromLocation() {
  if (typeof window === "undefined") {
    return DEFAULT_ENTRY_SOURCE;
  }

  const hash = String(window.location?.hash ?? "");
  const hashWithoutSharp = hash.startsWith("#") ? hash.slice(1) : hash;
  const path = hashWithoutSharp.split("?")[0];
  const segments = path.split("/").filter(Boolean);

  return normalizeRouteContext({
    source: segments[1],
    regimeType: segments[2],
  }).sourceEntree;
}

export default {
  DEFAULT_ENTRY_SOURCE,
  DEFAULT_REGIME_TYPE,
  normalizeSourceEntree,
  normalizeRouteContext,
  getSourceEntreeFromLocation,
  isValidRegimeType,
};
